import React from 'react';

import { useBoard, useDragAndDrop } from '../../hooks';
import Skeleton from './Skeleton';
import StatusGroup from './StatusGroup';

const ListView = () => {
  const { isLoading, statuses } = useBoard();

  useDragAndDrop();

  if (isLoading) return <Skeleton />;

  return (
    <div className="flex flex-col">
      {statuses.map((status) => (
        <StatusGroup key={status.id} status={status} />
      ))}
    </div>
  );
};

export default ListView;
